import { render, staticRenderFns } from "./messageSource.vue?vue&type=template&id=1ebb657f&scoped=true&"
import script from "./messageSource.vue?vue&type=script&lang=js&"
export * from "./messageSource.vue?vue&type=script&lang=js&"
import style0 from "./messageSource.vue?vue&type=style&index=0&id=1ebb657f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb657f",
  null
  
)

export default component.exports